import React from 'react'
import { Typography } from '@mui/material'
import { routes } from '../../../routes'
import { Link } from '../../../components'

export const ERRORS_PAYMENT_FAILED = {
  title: 'Payment Issue',
  message:
    "We're sorry, but there was an issue processing your payment. Please check your payment details and try again. If the problem persists, contact your bank or try using a different payment method."
}

export const ERRORS_ALREADY_SUBSCRIBED = {
  title: 'You are already subscribed to this plan',
  message: (
    <Typography>
      Go to your &nbsp;
      <Link
        to={routes.profile.path}
        underline='always'
      >
        <strong>profile page</strong>
      </Link>
      &nbsp;if you want to update it.
    </Typography>
  )
}

export const ERROR_CARD_PAYMENT_FAILED = {
  title: 'Payment Issue',
  message: 'Card transaction failed. Please check your payment details and try again or use a different payment method.'
}

export const ERROR_PAYPAL_PAYMENT_FAILED = {
  title: 'Payment Issue',
  message: 'Paypal transaction failed. Please try again or use a different payment method.'
}
